<template>
  <page-header
    :breadcrumRoutes="routes"
    title="Formulario de baja individual"
  />

  <a-card class="mb-2">
    <a-row>
      <a-col>
        <a-typography-title class="text-gray-8" :level="4">
          Datos corporativos
        </a-typography-title>
      </a-col>
    </a-row>
    <a-form
      name="form"
      layout="vertical"
      ref="formRef"
      :model="formState"
      :rules="rules"
    >
      <a-row :gutter="16" type="flex">
        <a-col :xs="24" :md="8">
          <a-form-item label="RUT" has-feedback name="rut">
            <input-rut v-model="formState.rut" @change="rutChange" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="8">
          <a-form-item label="Fecha de término" has-feedback name="affectDate">
            <a-date-picker
              :format="dateFormat"
              placeholder="DD-MM-AAAA"
              :style="{ width: '100%' }"
              v-model:value="formState.affectDate"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" type="flex" class="mb-3">
        <a-col :xs="24" :md="12">
          <a-form-item label="Empresa" name="company" has-feedback>
            <select-ordered
              placeholder="Selecciona una empresa"
              v-model="formState.company"
              :options="dataCompany"
              :disabled="blockCompany"
              @change="loadInsurance"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="12">
          <a-form-item label="Aseguradora" name="insurance" has-feedback>
            <select-ordered
              placeholder="Selecciona una aseguradora"
              v-model="formState.insurance"
              :options="dataInsurance"
              :disabled="blockInsurance"
              @change="loadPolicy"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="8">
          <a-form-item label="Pólizas" name="policy" has-feedback>
            <a-select
              placeholder="Selecciona una póliza"
              v-model:value="formState.policy"
              :disabled="blockPolicy"
              :options="dataPolicy"
              mode="multiple"
            ></a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-typography-title class="text-gray-8" :level="4">
        Mensaje a compañía aseguradora
      </a-typography-title>
      <a-row class="mb-2" :gutter="16">
        <a-col :xs="24" :md="12">
          <a-form-item
            has-feedback
            label="Escribe un mensaje para la compañía aseguradora"
            name="message"
          >
            <a-textarea
              v-model:value="formState.message"
              placeholder="Escribe aquí..."
              :rows="6"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="8">
          <a-form-item name="optionalFiles" label="Archivos opcionales">
            <a-upload
              :file-list="formState.optionalFiles"
              :multiple="true"
              :remove="handleRemoveOptional"
              :before-upload="beforeUploadOptional"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
            >
              <a-button>
                <upload-outlined />
                Subir Archivo
              </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-card>

  <a-row type="flex" class="justify-content-end">
    <a-col>
      <a-button
        size="large"
        class="px-4"
        type="primary"
        @click="formValidation"
      >
        Siguiente
      </a-button>
    </a-col>
  </a-row>

  <a-modal
    :wrapClassName="'modal-xs'"
    centered
    v-model:visible="visible"
    title="Resumen baja individual"
    @ok="handleOk"
    :closable="!loading"
    :maskClosable="false"
  >
    <template #footer>
      <a-row type="flex" justify="end">
        <a-col>
          <a-space>
            <a-button @click="handleOk" :disabled="loading">Cancelar</a-button>
            <a-button
              class="bg-blue-6"
              key="submit"
              type="primary"
              @click="onSubmit"
              :disabled="blockModal()"
              :loading="loading"
            >
              Enviar
            </a-button>
          </a-space>
        </a-col>
      </a-row>
    </template>
    <a-typography-title class="text-gray-8 fw-regular" :level="4">
      Datos colaborador
    </a-typography-title>
    <a-typography-title class="text-gray-8 fw-regular mb-4" :level="5">
      Revisa que los datos ingresados estén correctos.
    </a-typography-title>
    <a-descriptions class="mb-4" bordered>
      <a-descriptions-item label="RUT" :span="3">
        {{ formState.rut ? formState.rut : '' }}
      </a-descriptions-item>
      <a-descriptions-item label="Empresa" :span="3">
        {{
          formState.company >= 1
            ? dataCompany.find((x) => x.value === formState.company).label
            : ''
        }}
      </a-descriptions-item>
      <a-descriptions-item label="Aseguradora" :span="3">
        {{
          formState.company >= 1
            ? dataInsurance.find((x) => x.value === formState.insurance).label
            : ''
        }}
      </a-descriptions-item>
      <a-descriptions-item label="Pólizas" :span="3">
        {{
          formState.company >= 1
            ? dataPolicy
                .filter((e) => {
                  return formState.policy.find((f) => f == e.value);
                })
                .map((e) => e.label)
                .join()
            : ''
        }}
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>

  <a-modal
    v-model:visible="showPartialExclusionWarning"
    centered
    :maskClosable="false"
    :closable="!loading"
    wrapClassName="partial-exclusion-modal"
    :width="isMobile ? '90%' : 520"
    :style="isMobile ? { top: '24px' } : {}"
  >
    <template #title>
      <div class="partial-modal-title">
        <span>Confirmar baja parcial</span>
      </div>
    </template>

    <a-space direction="vertical" size="middle" style="width: 100%">
      <a-alert
        type="warning"
        show-icon
        message="Revisa cuidadosamente las pólizas antes de continuar"
        class="mb-2"
      />

      <p>
        Esta acción dará de baja solo
        <b>{{ formState.policy?.length || 0 }}</b>
        póliza(s) del titular.
      </p>

      <p>
        <b>Pólizas seleccionadas:</b>
        <br />
        {{
          dataPolicy
            .filter((p) => formState.policy?.includes(p.value))
            .map((p) => p.label)
            .join(', ')
        }}
      </p>

      <p>
        <b>Aún quedará vigente en {{ remainingPolicies.length }} póliza(s):</b>
        <br />
        {{ remainingPolicies.map((p) => p.label).join(', ') }}
      </p>
    </a-space>

    <template #footer>
      <a-space>
        <a-button @click="cancelPartialExclusion" :disabled="loading">
          Volver atrás
        </a-button>

        <a-button
          type="primary"
          @click="confirmPartialExclusion"
          :loading="loading"
        >
          Sí, continuar
        </a-button>
      </a-space>
    </template>
  </a-modal>

  <template v-if="showSucess">
    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="showSucess"
      centered
      footer=""
      :maskClosable="false"
    >
      <a-result
        centered
        status="success"
        title="Ticket creado"
        :sub-title="responseMsg"
      >
        <template #extra>
          <router-link
            class="justify-content-center d-flex"
            :to="{ name: 'BajaDetail', params: { id: idTicket } }"
          >
            <a-button key="console" type="primary">Ver ticket</a-button>
          </router-link>
        </template>
      </a-result>
    </a-modal>
  </template>
  <template v-if="showError">
    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="showError"
      centered
      footer=""
      :maskClosable="false"
    >
      <a-result
        centered
        status="error"
        title="Error"
        :sub-title="
          errorMsg
            ? errorMsg
            : 'No se ha podido generar el ticket. Asegúrate de que exista un Ticket de Alta generado previamente.'
        "
      >
        <template #extra>
          <a-button type="primary" @click="() => handleOk()">Cerrar</a-button>
        </template>
      </a-result>
    </a-modal>
  </template>
  <pending-policy-modal
    :visible="showPendingPolicyModal"
    :conflicts="pendingPolicyConflicts"
    ticket-type-label="baja individual"
    :employee-rut="formState.rut"
    ticket-route-name="BajaDetail"
    @update:visible="showPendingPolicyModal = $event"
  />
</template>

<script>
import { reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import moment from 'moment';
import { useStore } from 'vuex';
import PageHeader from '@/components/page-header.vue';
import InputRut from '@/bewell-components/form-controls/input-rut.vue';
import SelectOrdered from '@/bewell-components/form-controls/select-ordered.vue';
import { UploadOutlined } from '@ant-design/icons-vue';
import {
  GET_LOGGED_USER,
  FETCH_COMPANY_BY_RUT,
  FETCH_INSURANCECOMPANY_BY_RUT,
  FETCH_POLICY_INSURANCE_COMPANY,
  POST_INDIVIDUAL_EXCLUSION
} from '@/store/types';
import rutHelper from '@/utils/Ruts';
import { onMounted, onUnmounted } from 'vue';
import PendingPolicyModal from '@/components/tickets/PendingPolicyModal.vue';
import { FETCH_TABLE_TICKETS_TEST } from '@/store/ticket/datatable/types';

const routes = [
  {
    path: '/bajas',
    breadcrumbName: 'Bajas'
  },
  {
    breadcrumbName: 'Individual'
  }
];

export default {
  name: 'BajaIndividual',
  components: {
    'page-header': PageHeader,
    'input-rut': InputRut,
    'select-ordered': SelectOrdered,
    'upload-outlined': UploadOutlined,
    PendingPolicyModal
  },
  setup() {
    const formRef = ref();
    const formState = reactive({
      rut: '',
      company: null,
      insurance: null,
      policy: [],
      affectDate: '',
      optionalFiles: [],
      message:
        'A través este medio solicitamos la baja del colaborador correspondiente al siguiente RUT:'
    });
    const dateFormat = 'DD-MM-YYYY';
    const showError = ref(false);
    const errorMsg = ref('');
    const showSucess = ref(false);
    const loading = ref(false);
    // Block Selects
    const blockCompany = ref(true);
    const blockInsurance = ref(true);
    const blockPolicy = ref(true);
    const dataCompany = ref([]);
    const dataInsurance = ref([]);
    const dataPolicy = ref([]);
    const searchingRut = ref(false);

    const isMobile = ref(false);

    const showPendingPolicyModal = ref(false);
    const pendingPolicyConflicts = ref([]);

    const checkMobile = () => {
      isMobile.value = window.innerWidth <= 480;
    };

    onMounted(() => {
      checkMobile();
      window.addEventListener('resize', checkMobile);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', checkMobile);
    });
    const formatRuts = () => {
      formState.rut = rutHelper.formatRut(formState.rut);
    };

    const checkCompany = async (rule, value) => {
      if (!value) {
        const errorMessage = 'Seleccione una empresa';
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();
    };
    const checkInsurance = async (rule, value) => {
      if (!value) {
        const errorMessage = 'Seleccione una aseguradora';
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();
    };

    /* const checkDate = async (rule, value) => {
      if (!value) {
        const errorMessage = 'Seleccione una fecha';
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();

    }; */

    // * RUT
    const validRut = ref(false);
    const checkRut = async (rule, value) => {
      if (!value) {
        const errorMessage = 'Ingrese RUT';
        validRut.value = false;
        return Promise.reject(errorMessage);
      }
      if (!rutHelper.validateRut(value)) {
        validRut.value = false;
        return Promise.reject('RUT no válido');
      }
      const data = await getCompanyByRut(rutHelper.normalizeRut(value));

      if (!data) {
        validRut.value = false;
        return Promise.reject('No se encuentra el RUT');
      }
      validRut.value = true;
      return Promise.resolve();
    };

    const getCompanyByRut = async (val) => {
      searchingRut.value = true;
      return await store
        .dispatch(FETCH_COMPANY_BY_RUT, rutHelper.normalizeRut(val))
        .then((response) => {
          dataCompany.value = response.data.map((a) => {
            return {
              value: a.id,
              label: a.businessName
            };
          });
          blockCompany.value = false;
          searchingRut.value = false;
          return response.data;
        })
        .catch(() => {
          searchingRut.value = false;
          validRut.value = false;
          blockCompanySelect();
          blockInsuranceSelect();
          blockPolicySelect();
        });
    };

    const handleRemoveOptional = (file) => {
      const index = formState.optionalFiles.indexOf(file);
      const newFileList = formState.optionalFiles.slice();
      newFileList.splice(index, 1);
      formState.optionalFiles = newFileList;
    };

    const beforeUploadOptional = (file) => {
      const MAX_FILES = 5;
      const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

      if (formState.optionalFiles.length >= MAX_FILES) {
        message.error('Solo puedes subir un máximo de 5 archivos');
        return false;
      }
      if (file.size > MAX_FILE_SIZE_BYTES) {
        message.error('El archivo debe ser menor a 5MB');
        return false;
      }

      formState.optionalFiles = [...formState.optionalFiles, file];
      return false;
    };

    // * Bloqueo de inputs

    const blockCompanySelect = () => {
      // formState.company = '';
      dataCompany.value.length = 0;
      blockCompany.value = true;
    };

    const blockInsuranceSelect = () => {
      // formState.insurance = '';
      dataInsurance.value.length = 0;
      blockInsurance.value = true;
    };

    const blockPolicySelect = () => {
      formState.policy = [];
      dataPolicy.value.length = 0;
      blockPolicy.value = true;
    };

    const rules = {
      company: [
        {
          required: true,
          validator: checkCompany,
          trigger: 'change'
        }
      ],
      insurance: [
        {
          required: true,
          validator: checkInsurance,
          trigger: 'change'
        }
      ],
      policy: [
        {
          type: 'array',
          required: true,
          message: 'Seleccione una póliza',
          trigger: 'change'
        }
      ],
      affectDate: [
        {
          required: true,
          message: 'Seleccione una fecha',
          trigger: 'change',
          type: 'object'
        }
      ],
      rut: [
        {
          required: true,
          validator: checkRut,
          trigger: 'change'
        }
      ]
    };

    const rutChange = () => {
      if (formState.company > 0) {
        formRef.value.resetFields(['company', 'insurance', 'policy']);
      }
    };

    const loadInsurance = async (value) => {
      try {
        formState.insurance = null;
        formState.policy = null;
        if (formState.insurance == null) {
          formRef.value.resetFields(['insurance', 'policy']);
          blockPolicy.value = true;
        }
        const response = await store.dispatch(FETCH_INSURANCECOMPANY_BY_RUT, {
          payload: rutHelper.normalizeRut(formState.rut),
          companyId: value
        });
        if (response.data.length == 0) {
          blockCompany.value = true;
          blockInsurance.value = true;
          blockPolicy.value = true;
          message.error(
            `El empleado ${rutHelper.normalizeRut(
              formState.rut
            )} no está vigente en la empresa`
          );
          blockInsurance.value = true;
        } else {
          dataInsurance.value = response.data.map((a) => {
            return {
              value: a.id,
              label: a.businessName
            };
          });
          blockInsurance.value = false;
        }
      } catch (error) {
        blockInsurance.value = true;
        console.log(error);
      }
    };

    const loadPolicy = async () => {
      try {
        if (formState.policy.length > 0) {
          formRef.value.resetFields(['policy']);
        }
        if (dataPolicy.value.length > 0) {
          dataPolicy.value.splice(0);
        }
        if (formState.insurance) {
          formState.policy = [];
        }
        const response = await store.dispatch(FETCH_POLICY_INSURANCE_COMPANY, {
          company: formState.company,
          insurance: formState.insurance,
          rut: rutHelper.normalizeRut(formState.rut)
        });
        if (response.data) {
          dataPolicy.value = response.data.map((a) => {
            return {
              value: a.id,
              label: `${a.numberPolicy}`
            };
          });
          blockPolicy.value = false;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const onCollapse = (collapsed = Boolean, type = String) => {
      console.log(collapsed, type);
    };

    const onBreakpoint = (broken = Boolean) => {
      console.log(broken);
    };

    /* modal */
    const visible = ref(false);

    const showModal = () => {
      forceSubmit.value = false;

      visible.value = true;
    };

    const showPartialExclusionWarning = ref(false);
    const remainingPolicies = ref([]);
    const forceSubmit = ref(false);
    const cancelPartialExclusion = () => {
      showPartialExclusionWarning.value = false;
      forceSubmit.value = false;
    };

    const confirmPartialExclusion = () => {
      forceSubmit.value = true;
      showPartialExclusionWarning.value = false;
      onSubmit();
    };

    const handleOk = () => {
      visible.value = false;
      showError.value = false;
      forceSubmit.value = false;
    };

    const blockModal = () => {
      let blocked = true;
      if (
        formState.rut.length > 1 &&
        formState.company >= 1 &&
        formState.insurance >= 1 &&
        formState.affectDate !== ''
      ) {
        blocked = false;
      }
      return blocked;
    };

    // * Crear un ticket de alta
    const idTicket = ref('');
    const responseMsg = ref('');
    const store = useStore();

    const TICKET_TYPE = 'Baja';

    const getLastTicketState = (ticket) => {
      if (ticket?.states?.length) {
        return [...ticket.states]
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
          .at(-1);
      }
      return ticket?.state ?? null;
    };

    const isTicketPending = (ticket) => {
      if (ticket?.isRequesting === true || ticket?.state === 'requested') {
        return true;
      }
      const lastState = getLastTicketState(ticket);
      const stateId = lastState?.stateId ?? lastState?.id;

      if (stateId === undefined || stateId === null) return false;

      // (según tu lógica actual: 3 y 4 son estados finales)
      return stateId !== 3 && stateId !== 4;
    };

    const normalizePolicyValue = (value) => {
      if (value === null || value === undefined) return '';
      return String(value).trim().toLowerCase();
    };

    const extractTicketPolicies = (ticket) => {
      const policies = ticket?.policies ?? [];
      if (Array.isArray(policies)) {
        return policies
          .map((p) => p?.id ?? p?.policyId ?? p?.numberPolicy ?? p)
          .map(normalizePolicyValue)
          .filter(Boolean);
      }
      return [normalizePolicyValue(policies)].filter(Boolean);
    };
    const checkPendingPolicies = async () => {
      const normalizedRut = rutHelper.normalizeRut(formState.rut);

      // Si no hay rut o no hay pólizas seleccionadas → no hay nada que revisar
      if (
        !normalizedRut ||
        !Array.isArray(formState.policy) ||
        formState.policy.length === 0
      ) {
        pendingPolicyConflicts.value = [];
        return false;
      }

      const resp = await store.dispatch(
        FETCH_TABLE_TICKETS_TEST,
        `type=${encodeURIComponent(
          TICKET_TYPE
        )}&employeeRut=${normalizedRut}&page=1&items_per_page=50`
      );

      const rows = resp?.data?.rows || [];
      const pendingRows = rows.filter(isTicketPending);

      const policyLabelsById = new Map(
        (Array.isArray(dataPolicy.value) ? dataPolicy.value : []).map((p) => [
          p.value,
          p.label
        ])
      );
      const selectedPolicies = formState.policy.flatMap((id) => {
        const normalizedId = normalizePolicyValue(id);
        const label = policyLabelsById.get(id);
        const normalizedLabel = normalizePolicyValue(label);
        return [normalizedId, normalizedLabel].filter(Boolean);
      });

      const conflicts = [];

      pendingRows.forEach((row) => {
        const rowPolicies = extractTicketPolicies(row);

        selectedPolicies.forEach((policyKey) => {
          if (rowPolicies.includes(policyKey)) {
            conflicts.push({
              id: `${row.id}-${policyKey}`,
              policy: policyKey,
              ticketId: row.id
            });
          }
        });
      });

      if (conflicts.length > 0) {
        pendingPolicyConflicts.value = conflicts;
        showPendingPolicyModal.value = true;
        return true;
      }

      pendingPolicyConflicts.value = [];
      return false;
    };

    const onSubmit = async () => {
      if (loading.value) return;

      try {
        const remaining = computeRemainingPolicies();

        // 2) Si hay pólizas restantes y aún no confirmaron, mostrar warning y salir
        if (remaining.length > 0 && !forceSubmit.value) {
          remainingPolicies.value = remaining;
          showPartialExclusionWarning.value = true;
          return;
        }
        loading.value = true;
        const formData = new FormData();
        formData.append('rut', rutHelper.normalizeRut(formState.rut));
        formData.append('brokerId', store.getters[GET_LOGGED_USER].id);
        formData.append('companyId', formState.company);
        formData.append(
          'endDate',
          moment(formState.affectDate).startOf('day').toISOString()
        );
        formData.append('insuranceCompanyId', formState.insurance);
        formState.policy.forEach((policy) => {
          formData.append('policies[]', policy);
        });
        formState.optionalFiles.forEach((file) => {
          formData.append('optionalFile', file);
        });
        formData.append('message', formState.message);
        const resp = await store.dispatch(POST_INDIVIDUAL_EXCLUSION, formData);

        if (resp.status === 200) {
          const newTicketId =
            resp?.data?.ticket?.id ?? resp?.data?.id ?? resp?.id;
          if (newTicketId) {
            idTicket.value = newTicketId;
          }
          responseMsg.value = resp.data.message;
          showSucess.value = true;
          formRef.value.resetFields();
        }
      } catch (error) {
        console.log(error);
        loading.value = false;
        showError.value = true;
        errorMsg.value = error?.response?.data?.message;
      } finally {
        visible.value = false;
        loading.value = false;
      }
    };
    const computeRemainingPolicies = () => {
      const selectedIds = Array.isArray(formState.policy)
        ? formState.policy
        : [];

      const active = Array.isArray(dataPolicy.value)
        ? dataPolicy.value.map((p) => ({
            id: p.value,
            label: p.label
          }))
        : [];

      const remaining = active.filter((p) => !selectedIds.includes(p.id));
      return remaining;
    };

    // * Validación de formulario
    const formValidation = () => {
      formRef.value
        .validate()
        .then(async () => {
          const hasPendingPolicy = await checkPendingPolicies();
          if (hasPendingPolicy) return;

          showModal();
        })
        .catch((error) => {
          console.log('Error', error);
        });
    };

    return {
      // Variables
      routes,
      formRef,
      formState,
      visible,
      showError,
      showSucess,
      loading,
      dateFormat,
      blockCompany,
      blockInsurance,
      blockPolicy,
      rules,
      dataCompany,
      dataInsurance,
      dataPolicy,
      idTicket,
      showPendingPolicyModal,
      pendingPolicyConflicts,
      // Methods
      onCollapse,
      onBreakpoint,
      blockModal,
      handleOk,
      showModal,
      onSubmit,
      loadInsurance,
      rutChange,
      loadPolicy,
      formValidation,
      formatRuts,
      value1: ref(),
      errorMsg,
      handleRemoveOptional,
      beforeUploadOptional,
      responseMsg,
      showPartialExclusionWarning,
      remainingPolicies,
      cancelPartialExclusion,
      confirmPartialExclusion
    };
  }
};
</script>

<style>
.partial-exclusion-modal .partial-modal-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
}

.partial-exclusion-modal .partial-modal-title .pi {
  font-size: 22px;
  color: #faad14;
}
</style>
